<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
        </tt-card>

        <tt-list [ttData]="itemsListStocks"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="searchstock_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="20">
                    <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
                </tt-divider-pane>

                <tt-divider-pane ttSize="80">
                    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #selectionCriterias>
    <ng-container *ngIf="!!setting">
        <tt-select *ngIf="setting.stockplace_from_user !== '1'" ttRememberId="stock.businessco_no" ttLabel="businessco" [(ttModel)]="setting.businessco_no" (ttModelChange)="onChanged($event, 'businessco_no')" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
        <tt-select ttRememberId="stock.stockplace_id" ttLabel="stockplace" [(ttModel)]="setting.stockplace_id" (ttModelChange)="onChanged($event, 'stockplace_id')" [ttData]="selectListStockPlaces" ttDataId="stockplace_id" ttDataName="stockplace_name"></tt-select>
        <tt-checkbox *ngIf="setting.show_search_only_active_products === '1'" ttRememberId="w_searchstock.search_only_active_products" ttLabel="search_only_active_products" [(ttModel)]="setting.search_only_active_products"></tt-checkbox>

        <form class="form-horizontal sp-0" name="formSearchStock" novalidate (ngSubmit)="searchItems()" method="get" role="form">
            <tt-input ttRememberId="stock.productsearch_searchtext" ttLabel="productsearch_searchtext" ttFocus="false" [(ttModel)]="setting.productsearch_searchtext" [ttButtons]="productSearchTextButtons"></tt-input>
        </form>
    </ng-container>
</ng-template>

<!--<tt-page class="col-xs-12 sp-0 height-full">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-select ng-if="vm.model.setting.stockplace_from_user !== '1'" class="col-xs-12 sp-0" tt-label="businessco" tt-model="vm.model.setting.businessco_no" tt-change="vm.onChanged($value, 'businessco_no')" tt-data="vm.model.selectListCompanies" tt-data-id="businessco_no" tt-data-name="company_name"></tt-select>
        <tt-select class="col-xs-12 sp-0" tt-label="stockplace" tt-model="vm.model.setting.stockplace_id" tt-change="vm.onChanged($value, 'stockplace_id')" tt-data="vm.model.selectListStockPlaces" tt-data-id="stockplace_id" tt-data-name="stockplace_name"></tt-select>
        <tt-checkbox ng-if="vm.model.setting.show_search_only_active_products === '1'" class="col-xs-12 sp-0" tt-label="search_only_active_products" tt-model="vm.model.setting.search_only_active_products" tt-change="vm.onChanged($value, 'search_only_active_products')"></tt-checkbox>

        <form class="form-horizontal im-no-pad" name="formSearchStockSearch" novalidate ng-submit="vm.searchStock()" method="get" role="form">
            <tt-input-buttons class="col-xs-12 sp-0" tt-label="productsearch_searchtext" tt-model="vm.model.setting.productsearch_searchtext" tt-change="vm.onChanged($value, 'productsearch_searchtext')" tt-placeholder="" tt-buttons="vm.model.productSearchTextButtons" tt-readonly="false"></tt-input-buttons>
        </form>
    </tt-card>

    <im-list-directive class="col-xs-12 sp-0" ng-if="vm.model.gridView === false" list-items="vm.model.itemsListStocks" badge="" ltype="" design-var="s12t0"></im-list-directive>
    <tt-grid class="col-xs-12 sp-0 flex-1 height-full" tt-options="vm.grid" ng-if="vm.model.gridView && vm.model.gridReady"></tt-grid>

    <tt-card class="col-xs-12 sp-0" ng-if="vm.model.setting.show_setting === '1'">
        <tt-button-settings class="col-xs-12 sp-0" tt-locked=""></tt-button-settings>
    </tt-card>
</tt-page>-->
